<template>
    <el-menu class="el-menu-vertical-demo"
             background-color="#505458"
             text-color="#fff"
             active-text-color="#ffd04b" :uniqueOpened=true :router=true :collapse="isCollapse" :collapse-transition="false">
        <div class="toggle-button" @click="toggleCollapse"><i class="el-icon-s-fold"></i></div>
        <el-submenu :index="item.name" v-for="(item, index) in (userMenus.length===0?userMenus:userMenus[0].children) " :key="index">
            <template slot="title">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.name }}</span>
            </template>
            <el-menu-item-group>
                <el-menu-item
                    :index="subItem.path"
                    v-for="(subItem, subIndex) in item.children"
                    :key="subIndex">
                    <i style="padding-left:20px" :class="subItem.icon"></i>
                    <span slot="title"> {{ subItem.name }}</span>
                </el-menu-item>
            </el-menu-item-group>
        </el-submenu>
    </el-menu>
</template>

<script>

import store from "@/store";

export default {
    name: "Aside",
    data() {
        return {
            isCollapse:false,
            userMenus: []
        }
    },
    methods: {
        reloadMenus(){
            console.log(this.$store.state.key+'222')
            this.userMenus = store.state.user.menus.filter(item => item.name === this.$store.state.key)
        },
        toggleCollapse() {
            this.isCollapse=!this.isCollapse;
            console.log("widthFlag="+this.isCollapse)
            this.$emit("widthFlag",this.isCollapse);
        }
    },
    mounted() {
        this.reloadMenus();
    },
}
</script>

<style scoped>
    .el-menu {
        border: 0 !important;  
        border-right-width: 0;
      }
    .toggle-button{
        background: #505458;
        font-size: 20px;
        color:white;
        text-align: center;
        line-height: 50px;
      }
    .toggle-button:hover{
        background: #404346;
    }
</style>
